import axios from "axios";

export const TOKEN_KEY = "dobler_token";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (id) => (id ? `${API}/files/${id}?auth=${localStorage.getItem(TOKEN_KEY)}` : null);
export const statementPdfUrl = (id, lang = "es") => `${API}/payments/statements/${id}/pdf?lang=${lang}&auth=${localStorage.getItem(TOKEN_KEY)}`;

export function errMsg(e, fallback = "Algo salió mal. Intenta de nuevo.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

const CHUNK = 4 * 1024 * 1024;

export async function uploadFile(file, kind, onProgress) {
  if (file.size <= CHUNK) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("kind", kind);
    const { data } = await api.post("/files/upload", fd, {
      onUploadProgress: (p) => onProgress?.(Math.round((p.loaded / (p.total || file.size)) * 100)),
    });
    return data;
  }
  const uploadId = crypto.randomUUID();
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    await api.post("/files/chunk", fd);
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const { data } = await api.post("/files/complete", {
    upload_id: uploadId, filename: file.name, content_type: file.type || "application/octet-stream", kind, total_chunks: total,
  });
  onProgress?.(100);
  return data;
}
